import { XBoldIcon } from '@/icons';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils';
import { useEditMode } from '../../focus/useIsEditMode';
import { QuizImage } from '../QuizImage';
export const EditableQuestionImage = ({
  imageUrl,
  isUploading,
  onRemove
}: {
  imageUrl?: string;
  isUploading: boolean;
  onRemove?: () => void;
}) => {
  const {
    isEditMode,
    onEditModeChange
  } = useEditMode();
  if (!imageUrl && !isUploading) return null;
  return <div className={cn('group relative flex h-[174.667px] max-h-[180px] w-full cursor-pointer items-center justify-center rounded-sm border border-opacity-assistive bg-neutral py-sm', 'mb-2xs')} onClick={e => {
    e.stopPropagation();
    onEditModeChange(true);
  }} data-sentry-component="EditableQuestionImage" data-sentry-source-file="EditableQuestionImage.tsx">
      {isUploading ? <QuizImage.Loading /> : <div className="relative flex h-full max-h-[150px] items-center justify-center">
          {isEditMode && <QuizImage.RemoveButton className={cn('right-[-3px] top-[-4px] shadow-xs')} onClick={() => onRemove?.()}>
              <XBoldIcon width={14} height={14} className="[&>*]:fill-white" />
            </QuizImage.RemoveButton>}
          <QuizImage.Container className="h-full border-0" onClick={() => {
        imageUrl && imageDetailModal.open(imageUrl);
      }}>
            <QuizImage.Thumbnail className="h-full max-h-[150px] w-auto max-w-full rounded-sm object-cover" onMouseDown={e => {
          e.stopPropagation();
          e.preventDefault();
        }} src={imageUrl} alt="question-image" />
          </QuizImage.Container>
        </div>}
    </div>;
};